import { Star, TrendingUp, Users, DollarSign } from "lucide-react";

const SocialProof = () => {
  const testimonials = [
    {
      role: "Fitness Creator, 25M+ followers",
      quote: "VCM changed everything for me. Finally keeping 100% of what I earn.",
      rating: 5,
    },
    {
      role: "Entertainment Creator, 10M+ followers",
      quote: "The community and support are unmatched. No contracts, just results.",
      rating: 5,
    },
    {
      role: "Lifestyle Creator, 5M+ followers",
      quote: "Best decision I ever made. Elite training and zero fees.",
      rating: 5,
    },
  ];

  return (
    <section className="py-24 bg-card">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Trusted by <span className="bg-gradient-to-r from-primary via-secondary to-accent bg-clip-text text-transparent">Rapid-Growth Influencers</span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Our network includes celebrity-level creators dominating TikTok Live
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto mb-16">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="p-6 rounded-xl bg-background border border-border hover:border-primary/50 transition-all hover:shadow-glow"
            >
              <div className="flex items-center space-x-1 mb-3">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="text-primary fill-primary" size={18} />
                ))}
              </div>
              <p className="text-muted-foreground italic mb-4">"{testimonial.quote}"</p>
              <p className="text-sm font-semibold text-primary">{testimonial.role}</p>
            </div>
          ))}
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="text-center p-6 rounded-xl bg-primary/5 border border-primary/20">
            <div className="text-4xl font-bold text-primary mb-2">$10M+</div>
            <p className="text-muted-foreground">Creator Earnings in 2024</p>
          </div>
          <div className="text-center p-6 rounded-xl bg-accent/5 border border-accent/20">
            <div className="text-4xl font-bold text-accent mb-2">300%</div>
            <p className="text-muted-foreground">Average Creator Growth</p>
          </div>
          <div className="text-center p-6 rounded-xl bg-secondary/5 border border-secondary/20">
            <div className="text-4xl font-bold text-secondary mb-2">100+</div>
            <p className="text-muted-foreground">Elite Creators</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
